import API from "../../../../services/api";

export const changePassword = async (data) => {

    const res = await API.put(

        "/user/change-password",

        data

    );

    return res.data;

};